import { render, staticRenderFns } from "./Postsell.vue?vue&type=template&id=df5c2ff4&scoped=true"
import script from "./Postsell.vue?vue&type=script&lang=js"
export * from "./Postsell.vue?vue&type=script&lang=js"
import style0 from "./Postsell.vue?vue&type=style&index=0&id=df5c2ff4&prod&lang=css"
import style1 from "./Postsell.vue?vue&type=style&index=1&id=df5c2ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5c2ff4",
  null
  
)

export default component.exports